/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SelfServiceDefaultValuesForAws extends models.SelfServiceDefaultValuesBase {
    getFixupPrototypeFunction() { return SelfServiceDefaultValuesForAws.fixupPrototype; }

    static newInstance(model: Partial<SelfServiceDefaultValuesForAws>): SelfServiceDefaultValuesForAws {
        let obj = Object.assign(new SelfServiceDefaultValuesForAws(), model);
        SelfServiceDefaultValuesForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SelfServiceDefaultValuesForAws>): SelfServiceDefaultValuesForAws {
        if (!model) return null;
        return SelfServiceDefaultValuesForAws.newInstance(<SelfServiceDefaultValuesForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SelfServiceDefaultValuesForAws) {
        if (!obj) return;

        models.SelfServiceDefaultValuesForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SelfServiceDefaultValuesForAws): boolean {
        if (models.SelfServiceDefaultValuesBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SelfServiceDefaultValuesForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Default Region
     */
    regions: string;

    /**
     * Default Subnet
     */
    subnet: string;

}
